import { EditProjectMembershipPage } from '@/pages/Practitioners/EditProjectMembership';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { practitionerId, membershipId } = Route.useParams();
  return <EditProjectMembershipPage practitionerId={practitionerId} membershipId={membershipId} />;
};

export const Route = createFileRoute('/_auth/practitioners/$practitionerId/project-membership/$membershipId')({
  component: RouteComponent,
});
